"use client";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";

interface APIKeyFormProps {
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
}

export function APIKeyForm({ config, onChange }: APIKeyFormProps) {
  const [showKey, setShowKey] = useState(false);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label className="text-white/80">API Key</Label>
        <div className="relative">
          <Input
            type={showKey ? "text" : "password"}
            value={(config.api_key as string) || ""}
            onChange={(e) => onChange({ api_key: e.target.value })}
            placeholder="Enter your API key"
            className="border-white/10 bg-white/5 pr-10 text-white placeholder:text-white/40"
          />
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="absolute right-1 top-1/2 h-8 w-8 -translate-y-1/2 text-white/40 hover:text-white"
            onClick={() => setShowKey(!showKey)}
          >
            {showKey ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </Button>
        </div>
      </div>

      <div className="space-y-2">
        <Label className="text-white/80">Key Name</Label>
        <Input
          value={(config.api_key_name as string) || "X-API-Key"}
          onChange={(e) => onChange({ api_key_name: e.target.value })}
          placeholder="X-API-Key"
          className="border-white/10 bg-white/5 text-white placeholder:text-white/40"
        />
        <p className="text-xs text-white/40">
          The header or query parameter name for the API key
        </p>
      </div>

      <div className="space-y-2">
        <Label className="text-white/80">Key Location</Label>
        <Select
          value={(config.api_key_location as string) || "header"}
          onValueChange={(value) => onChange({ api_key_location: value })}
        >
          <SelectTrigger className="border-white/10 bg-white/5 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="header">Header</SelectItem>
            <SelectItem value="query">Query Parameter</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
